import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    line: {
      width: '90px',
      border: '1px solid #A1AAE380',
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        width: '20px',
      },
    },
    dashedLine: {
      border: '1px solid #A1AAE380',
    },
    chip: {
      borderRadius: '4px',
      marginRight: '8px',
      fontSize: '13px',
      background: ' #A1AAE312',
      width: 32,
      border: '1px solid #A1AAE380',
      '& .MuiChip-label': {
           textOverflow: 'inherit',
      },

      '&.chipError': {
        color: '#e53935 !important',
        background: 'rgb(207,57,23,.26) !important',
      },
    },
    stepTitle: {
       color: '#303d8f !important',
      '&.hasError': {
        color: '#e53935 !important',
      },
    },
    root: {
      width: '100%',
      '& *, *:focus': {
        boxShadow: 'none !important',
      },
      '& .react-tabs__tab-list': {
        borderBottom: 0,
        display: 'flex',
        overflowX: 'auto',
        overflowY: 'hidden',
        alignItems: 'center',
        '&::-webkit-scrollbar': {
          width: 2,
          height: 4,
          borderRadius: 10,
        },

        /* Track */
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: 10,
        },

        /* Handle */
        '&::-webkit-scrollbar-thumb': {
          background: '#e0e0e0',
          borderRadius: 10,
        },

        /* Handle on hover */
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#bdbbbb',
          borderRadius: 10,
        },
      },
      '& .react-tabs__tab': {
        border: 'none',
        color: '#546e7a',
        boxShadow: 'none',
        borderRadius: 0,
        outline: 'none',
        fontWeight: 500,
        fontSize: 14,
        transition: 'ease border .25s',
        borderBottom: '2px solid transparent',
        '&--selected': {
          color: theme.palette.primary.main,
          borderBottom: 0,
          '& .MuiChip-root': {
            color: '#ffffff',
            background: '#303d8f',
            BorderColor: '#303d8f',
          },
        },
        '&:focus:after': {
          display: 'none',
          borderBottom: `2px solid ${theme.palette.primary.main}`,
        },
      },
    },
    panelsContainer: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    actionContainer: {
      paddingTop: theme.spacing(2),
      justifyContent: 'flex-end',
      flexDirection: ' row',
      alignItems: 'center',
      gap: '16px',
      display: 'flex',
    },
    stepperAction: { color: theme.palette.primary.main },
    errors: {
      background: 'rgba(100,0,0,.15)',
      color: 'red',
      height: 22,
      paddingInlineStart: theme.spacing(1),
      paddingInlineEnd: theme.spacing(1),
      paddingTop: theme.spacing(0.3),
      display: 'inline-block',
      borderRadius: 100,
      marginInlineStart: theme.spacing(1.4),
    },
  };
});
